import type { ProgramConsentAttributes } from '@/server/models/ProgramConsent'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import type { ConsentUserType } from './constants'
import UserQ from './UserQ'
import WorldQ from './WorldQ'

const ProgramConsentQ = {
  ...makeQueryModelV2<ProgramConsentAttributes>('program_consent')([
    'id',
    'user_id',
    'type',
    'world_id',
    'completed_at',
    'responses',
    'updated_at',
    'created_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: ProgramConsentQ.user_id,
    },
    World: {
      query: WorldQ,
      foreignKey: WorldQ.id,
      sourceKey: ProgramConsentQ.world_id,
    },
  }),

  where: (
    {
      id,
      userId,
      type,
      worldId,
      groupBy = null,
      include = [],
      order = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      type?: ConsentUserType | null | SQLFragment<string>
      worldId?: number | null | SQLFragment<number>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      include?: IncludeAssociations
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<ProgramConsentAttributes> => SQL`
        FROM ${ProgramConsentQ}
        ${includeAssociationsToSql(ProgramConsentQ, include)}
        WHERE
            ${id != null ? SQL`${ProgramConsentQ.id} = ${id} AND` : SQL``}
            ${userId != null ? SQL`${ProgramConsentQ.user_id} = ${userId} AND` : SQL``}
            ${type != null ? SQL`${ProgramConsentQ.type} = ${type} AND` : SQL``}
            ${worldId != null ? SQL`${ProgramConsentQ.world_id} = ${worldId} AND` : SQL``}
            ${paranoid ? SQL`${ProgramConsentQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default ProgramConsentQ
